/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './CrossIcon.style';

import svg from './cross.svg';

type Props = {
  className?: string,
  title?: string,
  large?: boolean,
  // Self passed
};

const useStyles = createUseThemeStyles(styles);

const CrossIcon = ({ className, title, large }: Props): React.Node => {
  const classes = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, className, {
    [classes['root-large']]: large,
  });

  return <BaseIcon className={rootClasses} svg={svg} title={title} />;
};

export default React.memo<Props>(CrossIcon);
